import cn from 'classnames';
import { ChangeEvent, useState } from 'react';
import { ReactComponent as TriangleArrowIcon } from '@assets/svg/triangle-arrow.svg';
import coinSvg from '@assets/svg/coin.svg';
import styles from './bet-input.module.scss';
import Modal from '@components/modal';
import useReduxState from '@hooks/useReduxState';
import ButtonOutlined from '@components/button-outlined';

interface IProps {
  value: string;
  className?: string;

  // eslint-disable-next-line no-unused-vars
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line no-unused-vars
  updateBet: (value: string) => void;
  duplicateBet: () => void;
  divideBetInHalf: () => void;
}

const BetInput = ({ divideBetInHalf, duplicateBet, onChange, updateBet, value, className = '' }: IProps): JSX.Element => {
  /* Hooks */

  const [userBalance] = useReduxState((state) => state.userData.balance);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);

  /* Handlers */

  const openModal = (): void => setModalOpen(true);
  const closeModal = (): void => setModalOpen(false);

  const betAllUserBalance = (): void => {
    updateBet(userBalance.toString());
    closeModal();
  };

  return (
    <>
      <div className={cn(styles.amount, className)}>
        <div className={styles.amount__labels}>
          <label>Bet</label>
          <label onClick={openModal}>All-in</label>
        </div>
        <div className={styles.inputContainer}>
          <img src={coinSvg} alt='Coin' />
          <input type='number' placeholder='0.00' pattern='^\d*(\.\d{0,2})?$' {...{ onChange, value }} />
          <div className={styles.multipliers}>
            <button type='button' onClick={duplicateBet}>
              <TriangleArrowIcon />
            </button>
            <button type='button' onClick={divideBetInHalf}>
              <TriangleArrowIcon />
            </button>
          </div>
        </div>
      </div>
      <Modal noExitButton width='auto' isOpen={isModalOpen} close={closeModal}>
        <section className={styles.popup}>
          <p>Bet all-in?</p>
          <div className={styles['button-group']}>
            <ButtonOutlined onClick={betAllUserBalance} color='green'>
              Ok
            </ButtonOutlined>
            <ButtonOutlined onClick={closeModal} color='red'>
              Cancel
            </ButtonOutlined>
          </div>
        </section>
      </Modal>
    </>
  );
};

export default BetInput;
